export const getPath = (): string => {
  const {
    location: { pathname },
  } = window

  return `${pathname}`
}
